module.exports = __webpack_public_path__ + "payment.jpg?0bc88bc4f9d5a91ca55db05fd945d4ce";


//////////////////
// WEBPACK FOOTER
// ./dist/payment.jpg
// module id = 269
// module chunks = 0